function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.9265615mm",
    height: "5.8328619mm",
    viewBox: "0 0 1.9265615 5.8328619",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.9285756,-96.604668)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 8.7551346,102.16172 q -0.1640625,0.0898 -0.3125,0.13281 -0.1445313,0.043 -0.2773438,0.043 -0.2265625,0 -0.3085937,-0.0977 -0.078125,-0.10157 -0.078125,-0.41407 0,-0.18359 0.042969,-1.32422 0.046875,-1.144527 0.046875,-2.109371 0,-0.289062 -0.00781,-0.515625 -0.00781,-0.230469 -0.023437,-0.417969 l -0.1171875,0.04687 q -0.421875,0.175782 -0.4921875,0.175782 -0.097656,0 -0.1484375,-0.05859 -0.050781,-0.0625 -0.050781,-0.179688 0,-0.07813 0.019531,-0.175781 0.023437,-0.09766 0.066406,-0.214844 0.3515625,-0.07422 0.7773437,-0.210937 0.4257813,-0.136719 0.5195313,-0.136719 0.1367187,0 0.1875,0.08203 0.054687,0.08203 0.054687,0.3125 0,0.0625 -0.023437,0.359375 -0.089844,1.332032 -0.089844,2.589847 0,1.00781 0.046875,1.45312 0.050781,0.44141 0.1679688,0.66016 z",
    style: {
      fontSize: 8,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit1);
export default __webpack_public_path__ + "static/media/digit-1.32d7d2dd9065e057e784ae1a85ae4e0a.svg";
export { ForwardRef as ReactComponent };